import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { OvertimeService } from '../../services/overtime.service';
import { EmployeeService } from '../../services/employee.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-display-overtime',
    templateUrl: './display-overtime.component.html',
    styleUrls: ['./display-overtime.component.css', '../../app.component.css']
})

export class DisplayOvertimeComponent implements OnInit {

    overtime: any = [];

    id: string;

    igdSubs: any;
    igeSubs: any;

    // ME QUEDE AQUI
    // FALTA MOSTRAR TODOS LOS DATOS Y EL UPDATE

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private overtimeService: OvertimeService,
                private employeeService: EmployeeService) {
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.igdSubs = this.overtimeService.getOvertime(this.id).subscribe(overtimeObj => {
                this.igdSubs.unsubscribe();

                this.overtime = overtimeObj;

                this.overtime.workDate = Utils.convertDatefromStringtoISOString(this.overtime.workDate);
                this.overtime.assignationDate = Utils.getDateTime(this.overtime.assignationDate);
            });

            
        });
    }

    ngOnInit() {

    }

}
